document.addEventListener('DOMContentLoaded', function () {

  /* ── SPLASH cycling ── */
  var splashSurface = document.getElementById('splashSurface');
  if (splashSurface) {
    var raw = splashSurface.dataset.imgs || '[]';
    var srcs = [];
    try { srcs = JSON.parse(raw); } catch(e) {}
    if (srcs.length) {
      var si = 0;
      splashSurface.style.backgroundImage = "url('" + srcs[0] + "')";
      setInterval(function () {
        si = (si + 1) % srcs.length;
        splashSurface.style.backgroundImage = "url('" + srcs[si] + "')";
      }, 900);
    }
  }

  window.vxEnter = function () {
    var s = document.getElementById('splash');
    if (s) { s.classList.add('gone'); setTimeout(function(){ s.remove(); }, 900); }
  };

  /* ── HERO cycling ── */
  window._heroIdx = 0;
  var heroImg = document.getElementById('heroImg');
  var heroTag = document.getElementById('heroTag');
  if (heroImg) {
    var hProds = [];
    try { hProds = JSON.parse(heroImg.dataset.products); } catch(e) {}
    window.vxHero = function (i) {
      window._heroIdx = i;
      heroImg.src = hProds[i].src;
      if (heroTag) heroTag.textContent = hProds[i].tag;
      document.querySelectorAll('.hdot').forEach(function(d,j){ d.classList.toggle('on', i===j); });
    };
    if (hProds.length > 1) {
      setInterval(function(){ window.vxHero((window._heroIdx + 1) % hProds.length); }, 3200);
    }
    heroImg.addEventListener('click', function(){
      if (hProds[window._heroIdx]) location.href = hProds[window._heroIdx].url;
    });
  }

  /* ── FACTORY output cycling ── */
  var fImg = document.getElementById('factoryImg');
  var fBadge = document.getElementById('factoryBadge');
  if (fImg) {
    var fImgs = [], fNames = [];
    try { fImgs = JSON.parse(fImg.dataset.imgs); } catch(e) {}
    try { fNames = JSON.parse(fImg.dataset.names); } catch(e) {}
    var fi = 0;
    if (fImgs.length > 1) {
      setInterval(function(){
        fi = (fi + 1) % fImgs.length;
        fImg.src = fImgs[fi];
        if (fBadge) fBadge.textContent = fNames[fi] || 'VERXPAD READY ✦';
      }, 4000);
    }
  }

  /* ── QUICK VIEW ── */
  var qvOv = document.getElementById('qvOv');
  window.vxOpenQv = function (el) {
    if (!qvOv) return;
    document.getElementById('qvImg').src = el.dataset.img || '';
    document.getElementById('qvName').textContent = el.dataset.title || '';
    document.getElementById('qvDesc').textContent = el.dataset.desc || '';
    document.getElementById('qvPrice').textContent = el.dataset.price || '';
    var rt = document.getElementById('qvRtag');
    var rarity = el.dataset.rarity || 'Core';
    var rslug = el.dataset.rslug || 'core';
    rt.textContent = rarity;
    rt.className = 'qv-rtag ccard-rtag--' + rslug;
    var btn = document.getElementById('qvBtn');
    if (btn) btn.href = el.dataset.url || '#';
    qvOv.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.vxCloseQv = function (e) {
    if (e && e.target !== qvOv) return;
    if (qvOv) qvOv.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ if(qvOv) qvOv.classList.remove('open'); document.body.style.overflow=''; }});

  /* ── ADD TO CART via Shopify AJAX ── */
  window.vxAddCart = function (e, variantId, title) {
    e && e.stopPropagation();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      vxToast(title + ' — ADDED ✓');
      vxUpdateCart();
    })
    .catch(function(){ vxToast('Oops — try again'); });
  };

  function vxUpdateCart() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(c){
        var el = document.getElementById('navCart');
        if (el) el.textContent = '🛍 Cart (' + c.item_count + ')';
      });
  }

  /* ── PRODUCT FORM (product page) ── */
  var pForm = document.getElementById('pform');
  if (pForm) {
    pForm.addEventListener('submit', function(e){
      e.preventDefault();
      var vid = pForm.querySelector('[name="id"]').value;
      var title = document.querySelector('.p-title') ? document.querySelector('.p-title').textContent : 'Pad';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
      .then(function(r){ return r.json(); })
      .then(function(item){
        vxToast(item.title + ' — ADDED ✓');
        vxUpdateCart();
      });
    });
  }

  /* ── PRODUCT PAGE thumbs ── */
  window.vxThumb = function (el) {
    var main = document.getElementById('pMainImg');
    if (main) main.src = el.dataset.full || el.src;
    document.querySelectorAll('.pthumb').forEach(function(t){ t.classList.remove('on'); });
    el.classList.add('on');
  };

  /* ── TOAST ── */
  window.vxToast = function (msg) {
    var t = document.getElementById('vx-toast');
    if (!t) return;
    t.textContent = msg;
    t.style.transform = 'translateY(0)';
    t.style.opacity = '1';
    setTimeout(function(){
      t.style.transform = 'translateY(120px)';
      t.style.opacity = '0';
    }, 2600);
  };

  /* ── RIPPLE ── */
  document.addEventListener('click', function(e){
    if (e.target.closest('button') || e.target.closest('a')) return;
    var d = document.createElement('div');
    d.className = 'ripple';
    d.style.left = e.clientX + 'px';
    d.style.top = e.clientY + 'px';
    document.body.appendChild(d);
    setTimeout(function(){ d.remove(); }, 700);
  });

  /* ── NAV scroll effect ── */
  var nav = document.getElementById('vxNav');
  if (nav) {
    window.addEventListener('scroll', function(){
      nav.style.boxShadow = window.scrollY > 20 ? '0 4px 40px rgba(0,0,0,.5)' : 'none';
    });
  }
});

/* ═══════════════════════════════════════
   ⭐ MINI-GAME — PADDY DIGS THE BOX ⭐
═══════════════════════════════════════ */
(function () {
  var stats = { pulls: 0, legendary: 0, ultra: 0, rare: 0 };
  var currentPad = null;
  var isRolling = false;

  function rollRarity() {
    var r = Math.random();
    if (r < 0.20) return { tier: 'LEGENDARY', cls: 'r-legendary', odds: '1 / 5', icon: '👑' };
    if (r < 0.40) return { tier: 'ULTRA RARE', cls: 'r-ultra', odds: '1 / 125', icon: '💎' };
    return { tier: 'RARE', cls: 'r-rare', odds: '1 / 500', icon: '🌟' };
  }

  function fireConfetti(container, burst) {
    var c = document.getElementById(container);
    if (!c) return;
    var colors = ['#2d8eff', '#ffd83d', '#ff4d8d', '#fff', '#a8d4ff'];
    var count = burst === 'legendary' ? 120 : burst === 'ultra' ? 80 : 50;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      p.style.left = Math.random() * 100 + '%';
      p.style.background = colors[Math.floor(Math.random() * colors.length)];
      p.style.animationDelay = (Math.random() * 0.4) + 's';
      p.style.animationDuration = (1.2 + Math.random() * 1) + 's';
      c.appendChild(p);
      setTimeout((function (el) { return function () { el.remove(); }; })(p), 2500);
    }
  }

  function setBubble(text) {
    var b = document.getElementById('mgPaddyBubbleText');
    var bubble = document.getElementById('mgPaddyBubble');
    if (b) b.textContent = text;
    if (bubble) {
      bubble.classList.remove('show');
      void bubble.offsetWidth;
      bubble.classList.add('show');
    }
  }

  function setFace(mode) {
    // modes: normal, strain, excited
    var eNormal = document.getElementById('mgEyesNormal');
    var eStrain = document.getElementById('mgEyesStrain');
    var mNormal = document.getElementById('mgMouthNormal');
    var mStrain = document.getElementById('mgMouthStrain');
    var mExcited = document.getElementById('mgMouthExcited');
    var sweat = document.getElementById('mgSweat');

    if (eNormal) eNormal.style.display = mode === 'strain' ? 'none' : '';
    if (eStrain) eStrain.style.display = mode === 'strain' ? '' : 'none';
    if (mNormal) mNormal.style.display = mode === 'normal' ? '' : 'none';
    if (mStrain) mStrain.style.display = mode === 'strain' ? '' : 'none';
    if (mExcited) mExcited.style.display = mode === 'excited' ? '' : 'none';
    if (sweat) sweat.style.display = mode === 'strain' ? '' : 'none';
  }

  function popRejectPad(rejectEl, img) {
    if (!rejectEl) return;
    rejectEl.style.backgroundImage = "url('" + img + "')";
    rejectEl.classList.remove('go');
    void rejectEl.offsetWidth;
    rejectEl.classList.add('go');
  }

  // Wire up box tap
  window.addEventListener('DOMContentLoaded', function () {
    var box = document.getElementById('mgBox');
    if (box) {
      box.addEventListener('click', function () {
        if (isRolling) return;
        vxPullPad();
      });
    }
    var hint = document.getElementById('mgTapHint');
    if (hint) {
      hint.addEventListener('click', function () {
        if (isRolling) return;
        vxPullPad();
      });
    }
  });

  window.vxPullPad = function () {
    if (isRolling) return;
    isRolling = true;

    var box = document.getElementById('mgBox');
    var paddy = document.getElementById('mgPaddy');
    var arm = document.getElementById('mgArm');
    var hint = document.getElementById('mgTapHint');
    var dataEl = document.querySelector('.mg-data');
    if (!box || !dataEl || !paddy) { isRolling = false; return; }

    var pads = [];
    try { pads = JSON.parse(dataEl.dataset.pads); } catch (e) { isRolling = false; return; }
    if (!pads.length) { isRolling = false; return; }

    // Pick the winning pad + 3 rejects
    var pick = pads[Math.floor(Math.random() * pads.length)];
    var rarity = rollRarity();
    currentPad = pick;
    var rejects = pads.slice().sort(function () { return Math.random() - 0.5; }).slice(0, 3);

    if (hint) hint.style.display = 'none';

    // ═══ PHASE 1: Paddy walks up ═══
    paddy.classList.add('walk-in');
    setBubble("LEMME CHECK... 👀");
    setFace('normal');

    // ═══ PHASE 2: Reach into the box (~1.4s in) ═══
    setTimeout(function () {
      box.classList.add('lid-open');
      arm.classList.add('reach-in');
      setBubble("HMMMM... 🤔");
    }, 1400);

    // ═══ PHASE 3: Struggle — face strains, arm shakes, reject pads pop out ═══
    setTimeout(function () {
      setFace('strain');
      arm.classList.add('shake');
      setBubble("NOT THIS ONE! 😤");
      popRejectPad(document.getElementById('mgReject1'), rejects[0].img);
    }, 2400);

    setTimeout(function () {
      setBubble("NAH... 🙅");
      popRejectPad(document.getElementById('mgReject2'), rejects[1].img);
    }, 3200);

    setTimeout(function () {
      setBubble("HOLD ON! 😳");
      popRejectPad(document.getElementById('mgReject3'), rejects[2].img);
    }, 4000);

    // ═══ PHASE 4: Found it! Excited face ═══
    setTimeout(function () {
      setFace('excited');
      arm.classList.remove('shake');
      setBubble("FOUND IT! ⚡✨");
    }, 4800);

    // ═══ PHASE 5: Pull the pad out (~5.6s in) ═══
    setTimeout(function () {
      arm.classList.remove('reach-in');
      arm.classList.add('pull-out');
      box.classList.remove('lid-open');
      box.classList.add('closed-pop');
    }, 5600);

    // ═══ PHASE 6: Reveal on screen (~6.5s in) ═══
    setTimeout(function () {
      showReveal(pick, rarity);
      stats.pulls++;
      if (rarity.tier === 'LEGENDARY') stats.legendary++;
      else if (rarity.tier === 'ULTRA RARE') stats.ultra++;
      else stats.rare++;
      var pullsEl = document.getElementById('mgPulls');
      var legEl = document.getElementById('mgLegendary');
      var ultraEl = document.getElementById('mgUltra');
      var rareEl = document.getElementById('mgRare');
      if (pullsEl) pullsEl.textContent = stats.pulls;
      if (legEl) legEl.textContent = stats.legendary;
      if (ultraEl) ultraEl.textContent = stats.ultra;
      if (rareEl) rareEl.textContent = stats.rare;
    }, 6500);
  };

  function showReveal(pick, rarity) {
    var reveal = document.getElementById('mgReveal');
    if (!reveal) { isRolling = false; return; }

    var img = document.getElementById('mgRevealImg');
    var name = document.getElementById('mgRevealName');
    var rarityEl = document.getElementById('mgRevealRarity');
    var oddsEl = document.getElementById('mgRevealOdds');
    var buyBtn = document.getElementById('mgRevealBuy');

    if (img) img.src = pick.img;
    if (name) name.textContent = pick.name;
    if (rarityEl) {
      rarityEl.textContent = rarity.icon + ' ' + rarity.tier + ' ' + rarity.icon;
      rarityEl.className = 'mg-reveal-rarity ' + rarity.cls;
    }
    if (oddsEl) oddsEl.textContent = 'Odds: ' + rarity.odds;
    if (buyBtn) buyBtn.href = pick.url || '#';

    reveal.classList.remove('open');
    void reveal.offsetWidth;
    reveal.classList.add('open');
    document.body.style.overflow = 'hidden';
    fireConfetti('mgRevealConfetti', rarity.tier === 'LEGENDARY' ? 'legendary' : rarity.tier === 'ULTRA RARE' ? 'ultra' : 'rare');
    vxToast(rarity.icon + ' PADDY GOT YOU A ' + rarity.tier + '!');
  }

  window.vxCloseReveal = function () {
    var reveal = document.getElementById('mgReveal');
    var box = document.getElementById('mgBox');
    var paddy = document.getElementById('mgPaddy');
    var arm = document.getElementById('mgArm');
    var hint = document.getElementById('mgTapHint');

    if (reveal) reveal.classList.remove('open');
    document.body.style.overflow = '';
    if (box) { box.classList.remove('lid-open','closed-pop'); }
    if (paddy) paddy.classList.remove('walk-in');
    if (arm) { arm.classList.remove('reach-in','shake','pull-out'); }
    setFace('normal');
    setBubble('TAP THE BOX! 👇');

    // reset reject pads
    ['mgReject1','mgReject2','mgReject3'].forEach(function (id) {
      var e = document.getElementById(id);
      if (e) e.classList.remove('go');
    });

    if (hint) hint.style.display = '';
    isRolling = false;
  };

  window.vxPullAgain = function () {
    vxCloseReveal();
    setTimeout(function () { vxPullPad(); }, 500);
  };

  window.vxEnterAndPlay = function () {
    if (typeof vxEnter === 'function') vxEnter();
    setTimeout(function () {
      var el = document.getElementById('minigame');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 900);
  };
})();

/* ═══════════════════════════════════════
   📱 MOBILE HAMBURGER MENU
═══════════════════════════════════════ */
window.vxToggleNav = function () {
  var burger = document.getElementById('vxBurger');
  var links = document.getElementById('vxNavLinks');
  if (burger) burger.classList.toggle('open');
  if (links) links.classList.toggle('open');
};

// close menu when a link is clicked
window.addEventListener('DOMContentLoaded', function () {
  var links = document.getElementById('vxNavLinks');
  if (!links) return;
  links.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      links.classList.remove('open');
      var burger = document.getElementById('vxBurger');
      if (burger) burger.classList.remove('open');
    });
  });
});

/* ═══════════════════════════════════════
   🎬 CINEMATIC REEL — timecode + serial
═══════════════════════════════════════ */
(function () {
  window.addEventListener('DOMContentLoaded', function () {
    var tc = document.getElementById('cineTC');
    var serial = document.getElementById('cineSerial');
    if (!tc && !serial) return;
    var t = 0;
    var serialNum = 1;
    setInterval(function () {
      t = (t + 1) % 24;
      if (tc) {
        var m = String(Math.floor(t / 60)).padStart(2, '0');
        var s = String(t % 60).padStart(2, '0');
        tc.textContent = m + ':' + s;
      }
      if (t === 0 && serial) {
        serialNum++;
        serial.textContent = String(serialNum).padStart(3, '0');
      }
    }, 1000);
  });
})();
